/*
 * @LastEditors: wei ze min
 */
import Http from "./../http";
/**
 * [canEatApi description]
 * @method getList @for @param {object} [params]  @return {Array} 返回数据
 * @var {[get]}
 */
const canEatApi = {
    // 获取分类列表
    // postSortApi: (urlParams, params, callback) => {
    //   Http.post("/foodtype/getFoodTypeList2", urlParams, params, res => {
    //     callback(res);
    //   }
    // },
    //   // 获取精选食物列表
    // postFoodListApi: (urlParams, params, callback) => {
    //     Http.post("/toolEat/getRecommendFoodList", urlParams, params, res => {
    //         callback(res);
    //     })
    // },
    // 获取分类列表
    getSortApi: (params, callback) => {
        Http.get("/foodtype/getFoodTypeListFront", params, res => {
            callback(res);
        })
    },
    // 获取精选食物列表
    getFoodListApi: (params, callback) => {
        Http.get("/toolEat/getRecommendFoodList", params, res => {
            callback(res);
        })
    },
    // 获取精选列表详情页数据
    getSecDetail: (params, callback) => {
        Http.get("/toolEat/foodDetails", params, res => {
            callback(res);
        })
    },
    // 获取对应id的食谱和商品
    getListByFoodId: (params, callback) => {
        Http.get("/toolEat/getListByFoodId", params, res => {
            callback(res);
        })
    },
    // 黑白榜查询食物列表
    onGrayListLoad: (urlParams, params, callback) => {
        Http.post("/toolEat/findBlackWhiteList", urlParams, params, res => {
            callback(res);
        })
    },
    // 食物分类页查询食物列表
    onCategoryListLoad: (urlParams, params, callback) => {
        Http.post("/foodtype/getFoodListByType", urlParams, params, res => {
            callback(res);
        })
    },
    // 搜索热词列表
    getFoodSearchHot: (params, callback) => {
        Http.get("/toolEat/foodSearchHot", params, res => {
            callback(res);
        })
    },
    // 搜索食物列表
    getSearchFood: (params, callback) => {
      Http.get("/toolEat/searchFood", params, res => {
          callback(res);
      })
    },
}

export default canEatApi;